module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/allclass-ece7afe43e3956812900078d96b20d7f.png";